import { withInterceptors, provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SuperComposLib } from '@devinforius/super-compos-17';
import { PrimengModule } from './shared/pipes/@primeng.module';
import { DialogService } from 'primeng/dynamicdialog';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { ConfigService } from './core/services/config.service';
import { PublicComponent } from './modules/public/public.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PrivateComponent } from './modules/private/private.component';
import { AssistanceComponent } from './modules/private/pages/assistance/assistance.component';
import { EditorComponent } from './shared/components/editor/editor.component';
import { MeetingsComponent } from './modules/private/pages/meetings/meetings.component';
import { DetailsComponent } from './modules/private/pages/meetings/details/details.component';
import { ListElementComponent } from './shared/components/list-element/list-element.component';
import { ElementComponent } from './shared/components/list-element/element/element.component';
import { AngularSplitModule } from 'angular-split';
import { PipesModule } from './shared/pipes/@pipes.module';
import { FichePointComponent } from './modules/private/pages/meetings/details/fiche-point/fiche-point.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { PointsComponent } from './modules/private/pages/points/points.component';
import { InfoGeneralComponent } from './shared/components/info-general/info-general.component';
import { CreateComponent } from './modules/private/pages/meetings/create/create.component';
import { SuperBoxListCustomComponent } from './shared/components/super-box-list/super-box-list.component';
import { CreatePointComponent } from './modules/private/pages/points/create/create.component';
import { AccordionsEditorComponent } from './shared/components/accordions-editor/accordions-editor.component';
import { NoInfoComponent } from './shared/components/no-info/no-info.component';
import { PointTablesComponent } from './modules/private/pages/points/tables/tables.component';
import { SkeletonTableComponent } from './shared/components/skeleton-table/skeleton-table.component';
import { SkeletonCardComponent } from './shared/components/skeleton-card/skeleton-card.component';
import { SkeletonListComponent } from './shared/components/skeleton-list/skeleton-list.component';
import { StatusChangeComponent } from './shared/components/modals/status-change/status-change.component';
import { MeetingSearchComponent } from './shared/components/modals/meeting-search/meeting-search.component';
import { ParticipantsChangeComponent } from './shared/components/modals/participants-change/participants-change.component';
import { InfosMeetingComponent } from './shared/components/infos-meeting/infos-meeting.component';
import { IntroConclusionPointComponent } from './shared/components/intro-conclusion-point/intro-conclusion-point.component';
import { InfosMeetingEditComponent } from './shared/components/modals/infos-meeting-edit/infos-meeting-edit.component';
import { PointReportComponent } from './shared/components/modals/point-report/point-report.component';
import { EventAddComponent } from './shared/components/modals/event-add/event-add.component';
import { ErrorInterceptor } from './core/providers/error-http-interceptor';
import { ErrorModalComponent } from './shared/components/modals/error-modal/error-modal.component';
import { ActionResponseModalComponent } from './shared/components/modals/action-response-modal/action-response-modal.component';
import { SuperListSimpleEDelibeComponent } from './shared/components/super-list-simple/super-list-simple.component';
import { ActionCreateModalComponent } from './shared/components/modals/action-create-modal/action-create-modal.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MarktocorrectionComponent } from './shared/components/modals/marktocorrection/marktocorrection.component';
import { VotesComponent } from './shared/components/votes/votes.component';
import { NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { PointsSearchComponent as PointsSearchComponentOld } from './shared/components/modals/points-search-old/points-search.component';
import { PointsSearchComponent } from './shared/components/modals/points-search/points-search.component';
import { PointSearchDisplayComponent } from './modules/private/pages/points/search-display/search-display.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DetailsPointsComponent } from './modules/private/pages/points/details/details.component';
import { ContactInfosService } from './core/services/contact-infos.service';
import { FilesComponent } from './modules/private/pages/points/create-update/component/files/files.component';
import { CreatePointFromIcourrierComponent } from './modules/private/pages/points/create-from-icourrier/create-icourrier.component';
import { DialogReleasesNotesComponent } from './shared/components/modals/dialog-releases-notes/dialog-releases-notes.component';
import { MassVotesComponent } from './shared/components/modals/mass-votes/mass-votes.component';
import { SuperAutoCompleteComponent } from './shared/components/super-autocomplete/super-autocomplete.component';
import { Import3PComponent } from './modules/private/pages/points/import3-p/import3-p.component';
import { ReportingComponent } from './shared/components/modals/reporting/reporting.component';
import { TableWithInputComponent } from './shared/components/table-with-input/table-with-input.component';
import { DuplicationPointComponent } from './shared/components/modals/duplication/duplication-point.component';
import { ConfirmDeactivateGuard } from './core/guards/confirm-deactivate.guard';
import { GuardConfirmModalComponent } from './shared/components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { GenerateDocLotComponent } from './shared/components/modals/generate-doc-lot/generate-doc-lot.component';
import { ConfirmDeactivateScanGuard } from './core/guards/confirm-deactivate-scan.guard';
import { HundredPointPipe } from './shared/pipes/format.pipe';
import { DragDropDirectiveDirective } from './shared/directives/drag-drop-directive.directive';
import { ConnectionsComponent } from './modules/private/pages/points/connections/connections.component';
import { SignFileComponent } from './shared/components/signFile/sign-file.component';
import { ActionsPointComponent } from './modules/private/pages/points/actions-point/actions-point.component';
import { ExportIdelibeModalComponent } from './shared/components/modals/export-idelibe-modal/export-idelibe-modal.component';
import { PortaliSignComponent } from './shared/components/portal-iSign/portal-isign.component';
import { SearchModalScanComponent } from './shared/components/scanV2/search-modal/search-modal.component';
import { HomeScanComponent } from './shared/components/scanV2/home/home-scan.component';
import { DetailScanComponent } from './shared/components/scanV2/details/detail-scan.component';
import { MergeDocumentsComponent } from './shared/components/modals/merge-documents/merge-documents.component';
import { CreateClassementComponent } from './modules/private/pages/points/create-update/component/infos/classement/create-classement.component';
import { CreateFolderComponent } from './modules/private/pages/points/create-update/component/infos/folder/create-folder.component';
import { SearchClassementComponent } from './modules/private/pages/points/create-update/component/infos/search-classement/search-classement.component';
import { MovePointsComponent } from './modules/private/pages/points/move/move-points.component';
import { InfosComponent } from './modules/private/pages/points/create-update/component/infos/infos.component';
import { InfosFormComponent } from './modules/private/pages/points/create-update/component/infos/infos-form.component';
import { ContentComponent } from './modules/private/pages/points/create-update/component/content/content.component';
import { MergeCompliantExtractsComponent } from './shared/components/modals/merge-compliant-extracts/merge-compliant-extracts.component';
import { IViewerModule } from '@devinforius/i-viewer';
import { IDelibeLibModule } from '@devinforius/i-delibe-lib';
import { INavigationModule } from '@devinforius/i-navigation';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MeterGroupModule } from 'primeng/metergroup';
import { PaginatorModule } from 'primeng/paginator';
import { AddRecipientsComponent } from './shared/components/add-recipients/add-recipients.component';
import { ReleaseNotesComponent } from './core/components/release-notes/release-notes.component';
import { SharedModule } from '@shared/shared.module';
import { PointLinksComponent } from './modules/private/pages/points/point-links/point-links.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TagModule } from 'primeng/tag';
import { PointsCategoriesComponent } from './modules/private/pages/points/points-categories/points-categories.component';
import { PointsAdvancedSearchComponent } from './modules/private/pages/points/points-advanced-search/points-advanced-search.component';
import { GeneralDataComponent } from './modules/private/pages/points/points-advanced-search/general-data/general-data.component';
import { SavedSearchesComponent } from './modules/private/pages/points/points-advanced-search/saved-searches/saved-searches.component';
import { MeetingSearchForPointsComponent } from './modules/private/pages/points/points-advanced-search/meeting-search-for-points/meeting-search-for-points.component';
import { MoreDataComponent } from './modules/private/pages/points/points-advanced-search/more-data/more-data.component';
import { AgentsComponent } from './modules/private/pages/points/points-advanced-search/agents/agents.component';
import { ActionsComponent } from './modules/private/pages/points/points-advanced-search/actions/actions.component';
import {
  ConfigSSO,
  HttpTokenInterceptor,
  SessionRestoreService,
  ssoInitializer,
  SsoModule,
  SsoService,
} from '@devinforius/i-sso';
import { environment } from 'src/environments/environment';
import { DevComponent } from './core/components/dev/dev.component';
import { PointFormComponent } from './modules/private/pages/points/point-form/point-form.component';
import { ActionsModule } from 'src/app/modules/private/pages/actions/actions.module';
import { logInterceptor } from './core/providers';

registerLocaleData(localeFr);

export function appInit(configService: ConfigService) {
  return () => configService.load().toPromise();
}

const authCodeFlowConfig: ConfigSSO = {
  issuer: environment['issuer'],
  redirectUri: environment['redirectUri'],
  clientId: environment['clientId'],
  scope: environment['scope'],
  debug: false,
  getJwks: true,
  getUserInfo: true,
  enableCheckSession: false,
};

@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    PrivateComponent,
    AssistanceComponent,
    EditorComponent,
    MeetingsComponent,
    DetailsComponent,
    ActionsPointComponent,
    ListElementComponent,
    ElementComponent,
    FichePointComponent,
    InfoGeneralComponent,
    CreateComponent,
    PointsComponent,
    SuperBoxListCustomComponent,
    CreatePointComponent,
    CreateClassementComponent,
    CreateFolderComponent,
    SearchClassementComponent,
    AccordionsEditorComponent,
    NoInfoComponent,
    PointTablesComponent,
    SkeletonTableComponent,
    SkeletonCardComponent,
    SignFileComponent,
    PortaliSignComponent,
    SkeletonListComponent,
    StatusChangeComponent,
    ParticipantsChangeComponent,
    InfosMeetingComponent,
    IntroConclusionPointComponent,
    InfosMeetingEditComponent,
    MeetingSearchComponent,
    PointReportComponent,
    EventAddComponent,
    ErrorModalComponent,
    ActionResponseModalComponent,
    SuperListSimpleEDelibeComponent,
    ActionCreateModalComponent,
    MarktocorrectionComponent,
    VotesComponent,
    PointsSearchComponentOld,
    PointsSearchComponent,
    PointSearchDisplayComponent,
    DetailsPointsComponent,
    FilesComponent,
    CreatePointFromIcourrierComponent,
    DialogReleasesNotesComponent,
    MassVotesComponent,
    SuperAutoCompleteComponent,
    Import3PComponent,
    ReportingComponent,
    TableWithInputComponent,
    DuplicationPointComponent,
    GuardConfirmModalComponent,
    GenerateDocLotComponent,
    DetailScanComponent,
    HomeScanComponent,
    HundredPointPipe,
    DragDropDirectiveDirective,
    ConnectionsComponent,
    SearchModalScanComponent,
    ExportIdelibeModalComponent,
    MergeDocumentsComponent,
    MovePointsComponent,
    InfosComponent,
    InfosFormComponent,
    ContentComponent,
    MergeCompliantExtractsComponent,
    AddRecipientsComponent,
    ReleaseNotesComponent,
    PointLinksComponent,
    PointsCategoriesComponent,
    PointsAdvancedSearchComponent,
    GeneralDataComponent,
    SavedSearchesComponent,
    MeetingSearchComponent,
    MeetingSearchForPointsComponent,
    MoreDataComponent,
    AgentsComponent,
    ActionsComponent,
    DevComponent,
    PointFormComponent,
  ],
  imports: [
    BrowserModule,
    SharedModule,
    FormsModule,
    IViewerModule,
    IEssentialsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    AppRoutingModule,
    PrimengModule,
    SuperComposLib,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      enableHtml: true,
    }),
    AngularSplitModule,
    PipesModule,
    DragDropModule,
    ScrollingModule,
    GoogleMapsModule,
    NgbTimepickerModule,
    NgxExtendedPdfViewerModule,
    RadioButtonModule,
    IDelibeLibModule,
    MeterGroupModule,
    INavigationModule,
    PaginatorModule,
    AutoCompleteModule,
    TagModule,
    SsoModule.forRoot(authCodeFlowConfig, environment),
    ActionsModule,
  ],
  providers: [
    provideHttpClient(withInterceptors([HttpTokenInterceptor, ErrorInterceptor, logInterceptor])),
    ConfigService,
    ConfirmDeactivateGuard,
    ConfirmDeactivateScanGuard,
    DialogService,
    ConfirmationService,
    ContactInfosService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [ConfigService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: ssoInitializer,
      deps: [SsoService, SessionRestoreService],
      multi: true,
    },

    { provide: LOCALE_ID, useValue: 'fr-FR' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
